<script>
	// NPM Modules
	import Link from 'svelte-navaid/Link.svelte';
	// Partials
	import DerivedMarketTemplates from '@/Partials/Sport/Manage/DerivedMarkets/_DerivedMarketTemplates.svelte';
	import ManageGroups from '@/Partials/Sport/Manage/DerivedMarkets/_ManageGroups.svelte';

	export let sport;
	export let tab;
</script>

<div>
	<div class="flex items-center justify-center w-full">
		<div class="btn-group">
			<Link
				href={`/sport/manage/${sport.id}/derived`}
				class="btn {tab === undefined || tab === null ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Derived Market Groups
			</Link>
			<Link
				href={`/sport/manage/${sport.id}/derived/markets`}
				class="btn {tab === 'markets' ? 'btn-primary-action' : 'btn-muted text-dark'}"
			>
				Derived Market Templates
			</Link>
		</div>
	</div>
	{#if sport}
		{#if tab === 'markets'}
			<DerivedMarketTemplates bind:sport />
		{:else}
			<ManageGroups bind:sport />
		{/if}
	{/if}
</div>
